<template>
    <div>
        <el-container>
            <el-header height="15%">
                <div class="row">
                    <div class="col-md-3">
                        <h4>Дисконтные карты</h4>
                    </div>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск" class="loyalty__filter">
                    <div class="row">
                        <div class="col-md-2">
                            <el-form-item label="Поиск по имени">
                                    <el-input v-model="query.name" @input="(e) => searchCard(e, 'name')"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Поиск по почте">
                                    <el-input v-model="query.email" @input="(e) => searchCard(e, 'email')"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Поиск по номеру карты">
                                    <el-input v-model="query.number" @input="(e) => searchCard(e, 'number')"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item label="Сортировка" class="loyalty-filter__sort">
                                <el-select :value="sortValue()" class="loyalty-filter__sort-select" width="400px" @change="(e) => sortCards(e)">
                                    <el-option value="created_at.asc"
                                               label="Дата добавления по возрастанию"></el-option>
                                    <el-option value="created_at.desc"
                                               label="Дата добавления по убыванию"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <el-table :data="cards" style="width: 100%">
                    <el-table-column
                            prop="id"
                            label="Id"
                            width="50"
                    />
                    <el-table-column
                            label="Номер карты"
                            prop="number"
                    />
                    <el-table-column
                            prop="email"
                            label="Почта владельца"
                    />
                    <el-table-column
                            prop="discount"
                            label="Скидка"
                    />
                    <el-table-column
                            prop="bonus"
                            label="Бонусы"
                    />
                    <el-table-column
                            label="Привязана к пользователю"
                    >
                    <template slot-scope="scope">
                        <p v-if="cards[scope.$index].user.full_name">{{ cards[scope.$index].user.full_name }}</p>
                        <p v-else>Нет</p>
                    </template>
                    </el-table-column>
                    <el-table-column
                            label="Дата добавления"
                            prop="date"
                    >
                        <template slot-scope="scope">
                            {{dateParse(cards[scope.$index].created_at)}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                    v-show="paginator"
                    background
                    layout="prev, pager, next"
                    :total="paginator.total"
                    :current-page.sync="paginator.current_page"
                    @current-change="getPage(paginator.current_page)"
                    :hide-on-single-page="false"
                    :page-size="paginator.per_page"
                    :page-count="paginator.last_page + 1"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from '../../store/mutation-types.js';
import qs from 'qs';

export default {
    data: function () {
        return {
            status: 0,
            cards: [],
            paginator: [],
            current: 0,
            total: 0,
            query: {
                number: null,
                name: null,
                email: null,
                sort: {
                    by: 'created_at',
                    order: 'asc'
                },
                limit: 8
            },
            searchTimeout: null,
        }
    },
    mounted() {
        this.getCards();
    },
    methods: {
        getCards: function () {
            this.$store.commit(SETPRELOADER_STATE, true)
            
            const queryParams = qs.stringify(this.query, {skipNulls: true});

            axios.get(`/discount-card?${queryParams}`).then((response) => {
                this.cards = response.data.data;
                this.paginator = response.data.meta;
                this.current = response.data.meta.current_page;
                this.total = response.data.meta.total;
            }).catch((errors) => {
                if (errors.status === 401) {
                    this.$router.push('/login');
                }
            }).finally(() => {
                this.$store.commit(SETPRELOADER_STATE, false)
            });
        },
        getPage: function (pageNum) {
            if (pageNum !== null) {
                const loader = setTimeout(() => {
                    this.$store.commit(SETPRELOADER_STATE, true)
                }, 400)

                const queryParams = qs.stringify(this.query, {skipNulls: true})

                axios.get('/discount-card/?page=' + pageNum + `&${queryParams}`).then((response) => {
                    this.paginator = response.data.meta;
                    this.cards = response.data.data;
                    this.current = response.data.meta.current_page;
                }).catch((errors) => {
                    if (errors.status === 401) {
                        this.$router.push('/login');
                    }
                }).finally(() => {
                    clearTimeout(loader)
                    this.$store.commit(SETPRELOADER_STATE, false)
                });
            }

            this.success = '';

            return this.paginator.first_page_url
        },
        searchCard(value, prop) {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }

            this.searchTimeout = setTimeout(() => {
                if (!value) this.query[prop] = null

                const queryParams = qs.stringify(this.query, {skipNulls: true})

                this.$store.commit(SETPRELOADER_STATE, true)

                axios.get(`/discount-card?${queryParams}`).then((response) => {
                    this.cards = response.data.data;
                    this.paginator = response.data.meta;
                    this.current = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                }).catch((errors) => {
                    if (errors.status === 401) {
                        this.$router.push('/login');
                    }
                }).finally(() => {
                    this.$store.commit(SETPRELOADER_STATE, false)
                });
            }, 500)
        },
        sortCards(value) {
            this.query.sort.by = value.split('.')[0]
            this.query.sort.order = value.split('.')[1]

            this.getCards()
        },
        sortQuery() {
            return `sort[by]=${this.query.sort.by}&order=${this.query.sort.order}`;
        },
        sortValue() {
            return this.query.sort.by + '.' + this.query.sort.order
        },
        addZero(value) {
            return value < 10 ? `0${value}` : value
        },
        dateParse(date) {
            const timestump = Date.parse(date);
            const dateObject = new Date(timestump); 

            const year = dateObject.getFullYear();
            const month = this.addZero(dateObject.getMonth() + 1);
            const day = this.addZero(dateObject.getDate());

            const hour = this.addZero(dateObject.getHours());
            const mins = this.addZero(dateObject.getMinutes());

            return `${year}.${month}.${day} ${hour}:${mins}`
        }
    }
}
</script>

<style lang="scss">
.loyalty-filter {
    &__sort {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .el-form-item__content {
            display: flex;
            min-width: 100%;
        }
    }

    &__sort-select {
        width: 100%;
    }
}
</style>
